export const CONNECTED = 'CONNECTED';
export const RECONNECTING = 'RECONNECTING';
export const DISCONNECTED = 'DISCONNECTED';
export const RESUBSCRIBING = 'RESUBSCRIBING';
export const SUSPENDED = 'SUSPENDED';